<template>
  <div class="modals" :class="{ active: isHandleOpenComponentMoreOption }" v-if="isBS">
    <!-- Modals More Option -->
    <div class="content-modal-more-option" :class="{ active: showMoreOptionModal }">
      <div class="content-header-modal-more-option">
        <p class="averta-regular label-16 color-black">Pilih Menu</p>
        <div class="is-clickable" @click="closeMoreOption">
          <XMarkIcon color="#000000" size="12px" />
        </div>
      </div>
      <div class="content-body-modal-more-option">
        <ul
          class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 gap-4 p-3"
        >
          <li
            v-if="dataHeader.project_homecare_id && (!dataHeader.cancelled_at && !dataHeader.cancelled_by && !dataHeader.cancelled_note)"
            @click="dataHeader.project_homecare_id && openWorkRestrictionModal()"
            style="background-color: #fafafa; padding: 0.85rem 1.25rem"
            class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center border-radius-10 c-w-100 is-clickable"
          >
            <div
              class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-3"
            >
              <span
                class="bullet-cancel-more-option is-flex is-flex-direction-row is-justify-content-center is-align-items-center is-clickable"
              >
                <CalendarIcon color="#ffffff" size="8px" />
              </span>
              <p class="averta-regular label-16">Pilih Hari/Tanggal Larangan Bekerja</p>
            </div>
            <div
              class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center gap-3"
            >
              <ChevronIcon color="#000000" size="16px" />
            </div>
          </li>
          <li
            @click="
              dataHeader.cancelled_at && dataHeader.cancelled_by && dataHeader.cancelled_note
                ? ''
                : openCancelModal()
            "
            style="background-color: #fafafa; padding: 0.85rem 1.25rem"
            class="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center border-radius-10 c-w-100"
            :class="
              dataHeader.cancelled_at && dataHeader.cancelled_by && dataHeader.cancelled_note
                ? ''
                : 'is-clickable'
            "
          >
            <div
              class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-3"
            >
              <span
                class="bullet-cancel-more-option is-flex is-flex-direction-row is-justify-content-center is-align-items-center is-clickable"
              >
                <XMarkIcon color="#ffffff" size="8px" />
              </span>
              <p
                v-if="
                  dataHeader.cancelled_at && dataHeader.cancelled_by && dataHeader.cancelled_note
                "
                class="averta-regular label-16"
              >
                Proyek Sudah Dibatalkan
              </p>
              <p v-else class="averta-regular label-16">Batalkan Proyek</p>
            </div>
            <div
              class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center gap-3"
            >
              <ChevronIcon color="#000000" size="16px" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Modals More Option -->

    <!-- Modals Cancel Project -->
    <div class="content-modal-cancel-project" :class="{ active: showCancelModal }">
      <!-- Header -->
      <div class="content-header-modal-cancel-project">
        <div
          class="is-flex is-flex-direction-row is-justify-content-flex-start is-align-items-center gap-3"
        >
          <StoreIcon color="#ffffff" />
          <p class="averta-bold label-22 color-white">Batalkan Proyek</p>
        </div>
        <div class="is-clickable" @click="closeCancelModal">
          <XMarkIcon color="#ffffff" size="12px" />
        </div>
      </div>

      <!-- Body -->
      <div class="content-body-modal-cancel-project gap-8">
        <!-- Title -->
        <div class="is-flex is-flex-direction-column is-align-items-flex-start c-w-100">
          <p class="averta-bold label-16 color-black">Batalkan Proyek</p>
          <p class="averta-regular label-16 color-black">
            Proses proyek akan otomatis tidak dilanjutkan
          </p>
        </div>

        <!-- Catatan Pembatalan -->
        <div class="is-flex is-flex-direction-column is-align-items-flex-start c-w-100 gap-2">
          <span class="is-flex is-align-items-center">
            <p class="averta-regular label-14 color-black">Catatan Pembatalan</p>
            <p class="averta-regular label-14 color-red">*</p>
          </span>
          <b-input
            type="textarea"
            class="c-w-100"
            v-model="note"
            placeholder="Masukkan alasan pembatalan"
          />
        </div>

        <!-- Upload Bukti -->
        <div class="is-flex is-flex-direction-column is-align-items-flex-start c-w-100 gap-2">
          <span class="is-flex is-align-items-center gap-1">
            <p class="averta-regular label-14 color-black">Bukti Alasan Pembatalan</p>
            <p class="averta-regular label-14 color-gray">
              (Opsional, max 20/{{ countPhoto }} file)
            </p>
          </span>

          <div
            ref="scrollContainer"
            class="is-flex is-align-items-flex-start c-w-100 gap-2"
            style="max-height: 100px; overflow-y: auto"
          >
            <!-- Preview File + Tombol Upload -->
            <transition-group name="fade-scale" tag="div" class="is-flex flex-wrap gap-2">
              <div
                v-for="(preview, index) in photoPreviews"
                :key="preview.id"
                class="preview-upload"
              >
                <span
                  @click="removePhoto(index)"
                  class="bullet-cancel-cancel-project is-flex is-justify-content-center is-align-items-center is-clickable"
                >
                  <XMarkIcon color="#ffffff" size="8px" />
                </span>
                <img :src="preview.url" alt="Preview" class="preview-image" />
              </div>

              <!-- Tambahkan ref ke elemen upload -->
              <div
                v-if="photoPreviews.length < 20"
                ref="uploadBtn"
                key="upload-btn"
                class="thumbnail-upload-photo"
                @click="$refs.fileInput.click()"
              >
                <div class="thumbnail-upload-photo-icon">
                  <CameraIconV2 color="#E10009" size="12px" />
                </div>
                <input
                  ref="fileInput"
                  type="file"
                  multiple
                  accept="image/*"
                  style="display: none"
                  @change="handleMultipleFileUpload"
                />
              </div>
            </transition-group>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="content-footer-modal-cancel-project">
        <ButtonApp
          height="2.5em"
          :is-bold="true"
          :isSecondary="false"
          :isDisabled="isSubmitDisabled"
          @click="submitCancelProject"
        >
          <p class="averta-bold">Batalkan Proyek</p>
        </ButtonApp>
      </div>
    </div>
    <!-- Modals Cancel Project -->

    <!-- Alert Max 20 File -->
    <div class="alert-max-file" :class="{ active: showAlertMaxFile }">
      <div
        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center c-w-100 gap-2"
      >
        <div
          class="is-flex is-flex-direction-row is-justify-content-center is-align-items-center c-w-100 gap-3"
        >
          <AlertIcon />
          <p class="averta-bold label-16 color-black">Maksimal 20 file</p>
        </div>
        <div
          class="is-flex is-flex-direction-row is-justify-content-flex-end is-align-items-center c-w-100"
        >
          <button class="btn-close-alert" @click="showAlertMaxFile = false">
            <p class="averta-bold label-114 color-white">Tutup</p>
          </button>
        </div>
      </div>
    </div>
    <!-- Alert Max 20 File -->

    <!-- Modals Edit Work Restriction Day -->
    <ModalEditWorkRestrictionDay
      :is-open="showEditWorkRestrictionDayModal"
      :project-id="dataHeader.id"
      @close="closeWorkRestrictionModal"
      @submitted="handleWorkRestrictionSubmitted"
    />
    <!-- Modals Edit Work Restriction Day -->

    <!-- Modals Confirm Cancel Project -->
    <div class="content-modal-confirm-cancel-project" :class="{ active: showConfirmCancelModal }">
      <div class="content-header-modal-confirm-cancel-project">
        <AlertConfirmModalsIcon />
      </div>

      <div class="content-body-modal-confirm-cancel-project">
        <p class="averta-bold label-22 color-black">Batalkan Proyek ?</p>
        <p class="averta-regular label-16 color-black">Pastikan seluruh informasi telah sesuai</p>
      </div>
      <div class="content-footer-modal-confirm-cancel-project gap-3">
        <ButtonApp
          v-if="!isLoadingSendData"
          height="3em"
          width="100%"
          :is-bold="true"
          :isSecondary="true"
          @click="closeConfirmCancelModal"
        >
          <p v-if="!isLoadingSendData" class="averta-bold">Cek Kembali</p>
        </ButtonApp>

        <ButtonApp
          height="3em"
          width="100%"
          :is-bold="true"
          :isSecondary="false"
          @click="openConfirmCancelModal"
          :isDisabled="isLoadingSendData"
        >
          <p v-if="!isLoadingSendData" class="averta-bold">Iya, Batalkan</p>
          <p v-else class="averta-bold">Sedang memproses...</p>
        </ButtonApp>
      </div>
    </div>
    <!-- Modals Confirm Cancel Project -->
  </div>
</template>

<script>
import {
  XMarkIcon,
  CameraIconV2,
  ChevronIcon,
  StoreIcon,
  CalendarIcon,
  AlertConfirmModalsIcon,
  AlertIcon
} from '@/components/icons'
import ButtonApp from '@/components/button/ButtonApp'
import ModalEditWorkRestrictionDay from '@/components/modal/ModalEditWorkRestrictionDay'
import { mapGetters } from 'vuex'

export default {
  name: 'ModalMoreMenuDetailProject',
  props: {
    isHandleOpenComponentMoreOption: {
      type: Boolean,
      default: false
    },
    dataHeader: {
      type: Object,
      default: () => {}
    },
    dataProps: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showCancelModal: false,
      showMoreOptionModal: false,
      showConfirmCancelModal: false,
      note: '',
      showEditWorkRestrictionDayModal: false,
      photoFiles: [],
      photoPreviews: [],
      showAlertMaxFile: false,
      countPhoto: 0,
      isLoadingSendData: false,
      isCancelled: false
    }
  },
  computed: {
    ...mapGetters({
      url: 'setup/getUrl',
      user: 'auth/user'
    }),
    isBS () {
      if (
        this.user.roles[0].name === 'Account Manager' ||
        this.user.roles[0].name === 'Business Support'
      ) {
        return true
      }
      return false
    },
    isSubmitDisabled () {
      return !this.note
    }
  },
  components: {
    ButtonApp,
    ChevronIcon,
    CameraIconV2,
    XMarkIcon,
    StoreIcon,
    CalendarIcon,
    AlertConfirmModalsIcon,
    AlertIcon,
    ModalEditWorkRestrictionDay
  },
  methods: {
    // Handle Close Modals
    closeMoreOption () {
      this.showMoreOptionModal = false
      this.$emit('closeMoreOption', true)
    },
    closeCancelModal () {
      this.showCancelModal = false
      this.showMoreOptionModal = true
      this.resetForm()
    },
    closeConfirmCancelModal () {
      this.showCancelModal = true
      this.showConfirmCancelModal = false
    },
    closeWorkRestrictionModal () {
      this.showEditWorkRestrictionDayModal = false
      this.showMoreOptionModal = true
    },
    // Handle Close Modals

    // Handle Open Modals
    openCancelModal () {
      this.showCancelModal = true
      this.showMoreOptionModal = false
    },
    openConfirmCancelModal () {
      this.showCancelModal = false
      this.showConfirmCancelModal = true
      this.cancelProject()
    },
    openWorkRestrictionModal () {
      this.showMoreOptionModal = false
      this.showEditWorkRestrictionDayModal = true
    },
    handleWorkRestrictionSubmitted () {
      this.$emit('closeMoreOption', true)
      this.resetForm()
      this.clearDestroyedScroll()
      this.clearModalsActive()
    },
    // Handle Open Modals

    // Handle Scroll Photo Thumbnail
    scrollToUploadThumbnail () {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer
        const uploadBtn = this.$refs.uploadBtn
        this.$refs.scrollContainer.style.scrollBehavior = 'smooth'

        if (container && uploadBtn) {
          const containerBottom = container.scrollTop + container.clientHeight
          const uploadOffset = uploadBtn.offsetTop + uploadBtn.clientHeight

          if (uploadOffset > containerBottom) {
            container.scrollTop = container.scrollHeight
          }
        }
      })
    },
    // Handle Scroll Photo Thumbnail

    handleMultipleFileUpload (e) {
      const files = Array.from(e.target.files)
      const maxFiles = 20 - this.photoFiles.length
      const valid = files.filter((f) => f.type.startsWith('image/')).slice(0, maxFiles)

      if (valid.length < files.length) {
        setTimeout(() => {
          this.showAlertMaxFile = true
        }, 500)
      }

      setTimeout(() => {
        this.showAlertMaxFile = false
      }, 5000)

      valid.forEach((file) => {
        const id = `${Date.now()}-${Math.random()}`
        this.photoFiles.push({ id, file })
        this.photoPreviews.push({ id, url: URL.createObjectURL(file) })
      })

      e.target.value = null

      this.scrollToUploadThumbnail()
    },

    removePhoto (index) {
      this.photoFiles.splice(index, 1)
      this.photoPreviews.splice(index, 1)
    },
    submitCancelProject () {
      this.$emit('submitCancel', {
        note: this.note,
        photoFiles: this.photoFiles.map((p) => p.file)
      })
      this.showConfirmCancelModal = true
      this.showCancelModal = false
    },
    resetForm () {
      this.note = ''
      this.photoFiles = []
      this.photoPreviews = []
    },
    destroyedScroll () {
      document.body.style.height = '100vh'
      document.body.style.width = '100vw'
      document.body.style.overflow = 'hidden'
      document.documentElement.style.position = 'fixed'
    },
    clearDestroyedScroll () {
      document.body.style.height = ''
      document.body.style.width = ''
      document.body.style.overflow = ''
      document.documentElement.style.position = ''
    },
    clearModalsActive () {
      this.showMoreOptionModal = false
      this.showCancelModal = false
      this.showConfirmCancelModal = false
      this.showEditWorkRestrictionDayModal = false
    },
    cancelProject () {
      this.isLoadingSendData = true

      const payload = {
        url: this.url,
        note: this.note,
        images: this.photoFiles.map((p) => p.file),
        project_id: this.dataHeader.id,
        offering_id: this.dataProps.offering_id,
        status: this.dataHeader.status
      }

      console.log(payload)

      this.$store
        .dispatch('project/cancelProject', payload)
        .then(() => {
          this.isLoadingSendData = false

          this.$emit('getDataProyekHeader', true)
          this.$emit('isCancelled', true)
          this.$emit('closeMoreOption', true)

          this.resetForm()
          this.clearDestroyedScroll()
          this.clearModalsActive()
          this.$buefy.toast.open({
            message: 'Sukses batalkan project',
            type: 'is-success'
          })
        })
        .catch((err) => {
          this.isLoadingSendData = false
          this.$emit('closeMoreOption', true)
          this.resetForm()
          this.clearDestroyedScroll()
          this.clearModalsActive()
          this.$buefy.toast.open({
            message: 'Gagal batalkan project',
            type: 'is-danger'
          })
          console.log(err)
        })
    }
  },
  watch: {
    isHandleOpenComponentMoreOption (val) {
      if (val === true) {
        this.showMoreOptionModal = true
        this.destroyedScroll()
      } else {
        this.showMoreOptionModal = false
        this.clearDestroyedScroll()
      }
    },
    photoFiles: {
      handler (newVal) {
        this.countPhoto = newVal.length
      }
    }
  }
}
</script>

<style scoped>
.modals {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(0);
  z-index: -1;
  opacity: 0;
  transition: backdrop-filter 0.5s ease-in-out, z-index 0.5s ease-in-out,
    background 0.5s ease-in-out, opacity 0.5s ease-in-out;
}

.modals.active {
  z-index: 9999;
  backdrop-filter: blur(5px);
  opacity: 1;
  background: rgba(0, 0, 0, 0.5);
}

.content-modal-more-option {
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 0;
  min-width: 0;
  max-width: 0;
  height: 500px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 1000px;
  background: #ffffff;
  box-shadow: 0px 5px 8px 0px #2525250d;
  transition: top 0.35s ease-in-out, opacity 0.25s ease-in-out, width 0.25s ease-in-out,
    min-width 0.25s ease-in-out, max-width 0.25s ease-in-out, zoom 0.25s ease-in-out,
    border-radius 0.25s ease-in-out;
  opacity: 0;
  zoom: 0;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.hide-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.content-modal-more-option.active {
  top: 50%;
  opacity: 1;
  width: 100%;
  min-width: 500px;
  max-width: 500px;
  zoom: 1;
  border-radius: 20px;
}

.content-header-modal-more-option {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-bottom: 1px solid #e1e1e1;
}

.content-body-modal-more-option {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
}

.bullet-cancel-more-option {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #868686;
}

.content-modal-cancel-project {
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 50%;
  min-width: 250px;
  max-width: 250px;
  height: max-content;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 1000px;
  background: #ffffff;
  box-shadow: 0px 5px 8px 0px #2525250d;
  transition: top 0.35s ease-in-out, opacity 0.25s ease-in-out, width 0.25s ease-in-out,
    min-width 0.25s ease-in-out, max-width 0.25s ease-in-out, zoom 0.25s ease-in-out,
    border-radius 0.25s ease-in-out;
  opacity: 0;
  zoom: 0;
}

.content-modal-cancel-project.active {
  top: 50%;
  opacity: 1;
  width: 100%;
  min-width: 500px;
  max-width: 500px;
  zoom: 1;
  border-radius: 20px;
}

.content-header-modal-cancel-project {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  background: #8b080d;
}

.content-body-modal-cancel-project {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  overflow: hidden;
}

.content-footer-modal-cancel-project {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 65px;
  justify-content: flex-end;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
  border-top: 1px solid #e1e1e1;
  background: #ffffff;
}

.bullet-cancel-cancel-project {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #868686;
}

.thumbnail-upload-photo {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 2px dotted #e10009;
  cursor: pointer;
}

.thumbnail-upload-photo-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
}

.flex-wrap {
  flex-wrap: wrap;
}

.preview-upload {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid #ddd;
}
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bullet-cancel-cancel-project {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #e10009;
}

.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.4s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.85);
}

.content-modal-confirm-cancel-project {
  position: absolute;
  top: -35%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 0;
  min-width: 0;
  max-width: 0;
  height: 500px;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
  border-radius: 1000px;
  background: #ffffff;
  box-shadow: 0px 5px 8px 0px #2525250d;
  transition: top 0.35s ease-in-out, opacity 0.25s ease-in-out, width 0.25s ease-in-out,
    min-width 0.25s ease-in-out, max-width 0.25s ease-in-out, zoom 0.25s ease-in-out,
    border-radius 0.25s ease-in-out;
  opacity: 0;
  zoom: 0;
}

.content-modal-confirm-cancel-project.active {
  top: 50%;
  opacity: 1;
  width: 100%;
  min-width: 500px;
  max-width: 500px;
  zoom: 1;
  border-radius: 20px;
}

.content-header-modal-confirm-cancel-project {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
}

.content-body-modal-confirm-cancel-project {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0;
  overflow: hidden;
}

.content-footer-modal-confirm-cancel-project {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 1rem 2rem;
}

.alert-max-file {
  position: fixed;
  top: -100%;
  left: 20px;
  display: flex;
  flex-direction: row;
  width: max-content;
  height: max-content;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  background: #ffffff;
  transition: top 0.5s ease-in-out;
}

.alert-max-file.active {
  top: 20px;
}

.btn-close-alert {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: max-content;
  height: max-content;
  border-radius: 5px;
  margin: 0;
  padding: 0.15rem 0.5rem;
  background-color: #c6bebe;
  border: none !important;
  cursor: pointer;
}
</style>
